import { Colors, Fonts } from "Themes";
import React, { Component } from "react";

import LoadingIcon from "Components/LoadingIcon";
import styled from "styled-components";

export const StyledButton = styled.button`
  width: 100%;
  background-color: ${Colors.mainColor};
  color: white;
  border-radius: 5px;
  padding: 5px 10px 5px 10px;
  cursor: pointer;
  font-size: ${Fonts.fontSize.medium}px;
  border: solid 2px ${Colors.mainColor};
  &:hover {
    opacity: 0.9;
  }
  &:disabled {
    opacity: 0.5;
  }
  font-family: ${Fonts.primaryFontFamily};
`;

class Button extends Component {
  render() {
    const { onClick, type, disabled, title, style, fetching } = this.props;
    return (
      <StyledButton
        title={title}
        type={type}
        onClick={onClick}
        disabled={disabled}
        style={style}
      >
        {fetching ? <LoadingIcon /> : this.props.children}
      </StyledButton>
    );
  }
}

export default Button;
